//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import styles from './styles.module.scss';
import { useStore } from '../../store/store';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import { PhotoProgress } from 'src/onboarding/components/ui/photo-progress';

const LtsLayout = ({ children }) => {
  const { showPhotoProgress } = useRemoteConfig();
  const showPhotoProcessing = useStore((state) => state.showPhotoProcessing);
  return (
    <div
      className={styles.layout}
      style={showPhotoProcessing && showPhotoProgress ? { paddingTop: 60 } : { paddingTop: '' }}
    >
      {showPhotoProcessing && showPhotoProgress && <PhotoProgress />}
      {children}
    </div>
  );
};

export default LtsLayout;
